/* svg иконка галки в data uri */
var checkedImg = "data:image/svg+xml,%3Csvg viewBox='0 0 21 15' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20.4171 0.341705C20.8889 0.797323 20.8889 1.53601 20.4171 1.99163L7.94318 14.0354C7.35334 14.6049 6.39699 14.6049 5.80714 14.0354L1.1874 9.57495C0.715527 9.11937 0.715527 8.38063 1.1874 7.92505C1.6593 7.46947 2.42436 7.46947 2.89625 7.92505L6.87516 11.7668L18.7083 0.341705C19.1801 -0.113902 19.9452 -0.113902 20.4171 0.341705Z' fill='%23030721' fill-opacity='0.8'/%3E%3C/svg%3E";
export var radioButtonPortalTokens = {
  colors: {
    base: function base(_ref) {
      var color = _ref.color;
      return color.importance.secondary.base;
    },
    baseHover: function baseHover(_ref2) {
      var color = _ref2.color;
      return color.importance.secondary.hover;
    },
    baseActive: function baseActive(_ref3) {
      var color = _ref3.color;
      return color.importance.secondary.active;
    },
    checked: function checked(_ref4) {
      var color = _ref4.color;
      return color.importance.secondary.selected;
    },
    invalidBorder: function invalidBorder(_ref5) {
      var color = _ref5.color;
      return color.border.input.invalid.base;
    },
    focusBase: function focusBase(_ref6) {
      var color = _ref6.color;
      return color.border.focus.base;
    },
    focusHover: function focusHover(_ref7) {
      var color = _ref7.color;
      return color.border.focus.hover;
    },
    focusInvalid: function focusInvalid(_ref8) {
      var color = _ref8.color;
      return color.border.focus.invalid.base;
    },
    focusInvalidHover: function focusInvalidHover(_ref9) {
      var color = _ref9.color;
      return color.border.focus.invalid.hover;
    },
    label: function label(_ref10) {
      var color = _ref10.color;
      return color.text.black.base;
    }
  },
  paddingY: {
    s: 7,
    m: 10,
    l: 12
  },
  borderRadius: {
    s: 6,
    m: 8,
    l: 10
  },
  focusBoxShadowAttrs: "0 0 3px 1px",
  invalidBorderWidth: 2,
  iconSize: {
    s: 12,
    m: 17,
    l: 20
  },
  iconMarginsX: {
    s: 7,
    m: 9,
    l: 11
  },
  checkedImgDataUri: checkedImg
};